"use strict";
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOffers = void 0;

const utils_1 = require("../utils");

const getOffers = (jilFetch, options) => {
  const path = `offers`;
  const params = utils_1.omitIfNil({
    arrangement_code: options.arrangementCode,
    buying_program: options.buyingProgram,
    commitment: options.commitment,
    context: options.context,
    country: options.country,
    customer_segment: options.customerSegment,
    customer_ui: options.customerUI,
    ignore_market_end_date: options.ignoreMarketEndDate,
    ignore_release_date: options.ignoreReleaseDate,
    language: options.language,
    locale: options.locale,
    market_segment: options.marketSegment,
    merchant: options.merchant,
    offer_type: options.offerType,
    page: options.page,
    page_size: options.pageSize,
    price_point: options.pricePoint,
    processing_instructions: options.processingInstructions,
    sales_channel: options.salesChannel,
    service_providers: options.serviceProviders,
    show_availability_dates: options.showAvailabilityDates,
    spec_id: options.specId,
    term: options.term,
    use_telesales_date: options.useTelesalesDate
  }); // JIL Offers does not fall under /v2 base URL

  const version = '';
  return jilFetch(path, params, {
    headers: Object.assign({}, options.processingInstructionClientId && {
      'Processing-Instruction-Client-Id': options.processingInstructionClientId
    }),
    method: 'GET'
  }, version);
};

exports.getOffers = getOffers;